<div class="customer_id_container" [ngClass]="isMobile ? 'custom-width' : 'desktop-width'">
  <div class="searchBoxdiv list-search">
    @if (pageSource!='warrantyClaim') {
      <input type="text" class="Cust_ID_search"
        placeholder="{{ 'common.fselect_pageUploadPartPlaceholder' | cxTranslate }}" name="searchInput"
        [(ngModel)]="searchInput" />
      }
      <!-- NgIF for Placeholder -->
      @if (pageSource=='warrantyClaim') {
        <input type="text" class="Cust_ID_search"
          placeholder="{{ 'common.emea_core_customer_id_placeholder' | cxTranslate }}" name="searchInput"
          [(ngModel)]="searchInput" />
        }
      </div>
      <div class="customer_id_div">
        @for (data of customerId | filter: searchInput; track data; let i = $index) {
          <div class="customer_ID_Li list-styles" (click)="selected[i] = !selected[i]; selectedIds(customerId, data, i)">
            @if (pageSource !== 'warrantyClaim') {
              <span>
                <input type="checkbox" [(ngModel)]="selected[i]" />
              </span>
            }
            <div class="customer_id_list">
              {{ data?.salesArea1 }}&nbsp;|&nbsp; {{ data?.salesArea2 | cxTranslate }}&nbsp;|&nbsp;
              {{ data?.salesArea3 }}
            </div>
          </div>
        }
      </div>
    </div>